export default __webpack_public_path__ + "static/media/prj_3.d7e4a913.png";